export interface NewInvoiceNavigationRecipient {
    personId?: number | null;
    companyId?: number | null;
}

export function buildNewInvoiceNavigationParams(
    selectedPositions: ReadonlyArray<{ id?: number | null }>,
    recipient: NewInvoiceNavigationRecipient,
    bookingId?: number | null,
): Record<string, string | number> {
    const params: Record<string, string | number> = {
        positions: selectedPositions
            .map((position) => position.id)
            .filter((id): id is number => id != null)
            .join(','),
    };

    if (recipient.companyId) {
        params.company = recipient.companyId;
    } else if (recipient.personId) {
        params.person = recipient.personId;
    }

    if (bookingId) {
        params.bookingId = bookingId;
    }

    return params;
}
